// 中文
/* 
    // 赋值/在这里赋值
    CustomSelect: {
        '请选择': '请选择',
        '创作者': '创作者',
    },
    TopNav: {
        '创作者': '创作者',
        '游客': '游客',
    }
    ...

    // 取值/在代码里使用
    $t('CustomSelect.请选择) == '请选择'
    $t('CustomSelect.创作者) == '创作者'
    $t('TopNav.创作者) == '创作者'
    $t('TopNav.游客) == '游客'
    ....
*/
export default {
    CustomSelect: {
        '请选择': '请选择',
    },
    TopNav: {
        '创作者': '创作者',
        '游客': '游客',
        '请登录后体验完整功能': '请登录后体验完整功能',
        '登录': '登录',
        '免费试用': '免费试用',
        '退出登录': '退出登录',
        '个人中心': '个人中心',
        '我的视频': '我的视频',
        '额度管理': '额度管理',
        '首页': '首页',
        'AI创作': 'AI创作',
        '多参考': '多参考',
        '文本视频': '文本视频',
        '图片视频': '图片视频',
        '文生图': '文生图',
        '图生图': '图生图',
        '会员中心': '会员中心',
        '概览': '概览',
        '我的创作': '我的创作',
        '账单管理': '账单管理',
        '生成任务': '生成任务',
        '价格': '价格',
        '新闻资讯': '新闻资讯',
        '确定要退出登录吗？': '确定要退出登录吗？',
        '提示': '提示',
        '确定': '确定',
        '取消': '取消',
        '退出成功': '退出成功',
        '视频展示': '视频展示'
    },
    AiLayout: {
        'AI创作中心': 'AI创作中心',
        '视频生成': '视频生成',
        '图片生成': '图片生成',
        '我的作品': '我的作品',
        '我的创作': '我的创作',
        '今日剩余额度': '今日剩余额度',
        '多参考': '多参考',
        '文本视频': '文本视频',
        '图片视频': '图片视频',
        '文生图': '文生图',
        '图生图': '图生图',
    },
    HomeLayout: {
        '下一代AI视频生成平台': '下一代AI视频生成平台，让创意瞬间变为现实',
        '产品': '产品',
        'AI视频': 'AI视频',
        '价格方案': '价格方案',
        '新闻资讯': '新闻资讯',
        '支持': '支持',
        '帮助中心': '帮助中心',
        'API文档': 'API文档',
        '常见问题': '常见问题',
        '法律': '法律',
        '服务条款': '服务条款',
        '隐私政策': '隐私政策',
        '使用协议': '使用协议',
        '版权所有': '版权所有',
        '客服邮箱': '客服邮箱',
        '复制邮箱': '复制邮箱',
        '开发中': '开发中，请期待！',
        '链接已复制到剪贴板': '链接已复制到剪贴板',
    },
    MyLayout: {
        '创作者': '创作者',
        '退出登录': '退出登录',
        '概览': '概览',
        '我的创作': '我的创作',
        '会员中心': '会员中心',
        '额度管理': '额度管理',
        '账单管理': '账单管理',
        '生成任务': '生成任务',
        '确定要退出登录吗？': '确定要退出登录吗？',
        '提示': '提示',
        '确定': '确定',
        '取消': '取消',
        '退出成功': '退出成功'
    },
    Image: {
        "文本生成图片": "文本生成图片",
        "图片生成图片": "图片生成图片",
        "用文字描述": "用文字描述您想要的画面",
        "上传图片素材": "上传图片素材，支持多图生成",
        "图片描述": "图片描述",
        "描述您想要的图片": "详细描述您想要生成的图片内容，支持中文或英文...",
        "提示描述越详细效果越好": "提示：描述越详细，生成效果越好",
        "图片素材": "图片素材",
        "预览图片": "预览",
        "上传图片": "上传图片",
        "支持格式JPGPNG": "支持 JPG、PNG 格式",
        "最多": "最多",
        "张图片": "张",
        "超过大小限制": "超过10MB限制",
        "不是图片文件": "不是有效的图片文件",
        "最多上传": "最多只能上传",
        "请先上传图片": "请先上传图片素材",
        "请选择要生成的图片": "请选择要生成的图片",
        "生成结果": "生成结果",
        "重新生成成功": "重新生成成功",
        "模型": "AI 模型",
        "请选择模型": "请选择生成模型",
        "分辨率": "输出分辨率",
        "请选择分辨率": "请选择分辨率",
        "图片比例": "画面比例",
        "补充描述": "补充描述（可选）",
        "补充描述提示": "可选，描述您希望图片呈现的额外效果或风格",
        "开始绘制": "开始绘制",
        "开始生成": "开始生成",
        "生成中": "生成中，请稍候...",
        "生成成功": "生成成功",
        "图片生成成功": "图片生成成功！",
        "作品已保存到我的作品": "作品已保存到「我的作品」",
        "继续创作": "继续创作",
        "查看作品": "查看作品",
        "请输入图片描述": "请输入图片描述"
    },
    MyCreation: {
        '我的创作': '我的创作',
        '查看和管理您的所有作品': '查看和管理您的所有作品',
        '预览': '预览',
        '下载': '下载',
        '编辑': '编辑',
        '分享': '分享',
        '删除': '删除',
        '暂无作品': '暂无作品',
        '去创作': '去创作',
        '确定删除': '确定删除',
        '确定要删除作品': '确定要删除作品',
        '吗？': '吗？',
        '此操作不可恢复': '此操作不可恢复，请谨慎操作！',
        '取消': '取消',
        '分享作品': '分享作品',
        '复制链接': '复制链接',
        '全部': '全部',
        '视频': '视频',
        '图片': '图片',
        '正在下载:': '正在下载: ',
        '链接已复制到剪贴板': '链接已复制到剪贴板',
        '删除成功': '删除成功'
    },
    Video: {
        "文本生成视频": "文本生成视频",
        "图片生成视频": "图片生成视频",
        "智能视频生成": "智能视频生成",
        "输入文字描述": "输入文字描述",
        "上传1-9张图片": "上传1-9张图片",
        "上传图片视频音频": "上传图片视频音频",
        "视频描述": "视频描述",
        "描述您想要的视频场景": "描述您想要的视频场景",
        "提示": "提示",
        "图片素材": "图片素材",
        "最多上传": "最多上传",
        "张": "张",
        "预览": "预览",
        "上传图片": "上传图片",
        "支持格式": "支持 JPG、PNG 格式，单张不超过 10MB，最多",
        "AI": "AI 智能融合，将为您生成流畅的转场效果",
        "动态描述": "动态描述",
        "描述您希望图片如何动起来": "描述您希望图片如何动起来",
        "个": "个",
        "上传视频": "上传视频",
        "上传音频": "上传音频",
        "描述您希望视频呈现的效果": "描述您希望视频呈现的效果",
        "模型": "模型",
        "请选择模型": "请选择模型",
        "分辨率": "分辨率",
        "请选择分辨率": "请选择分辨率",
        "宽高比": "宽高比",
        "视频时长": "视频时长",
        "生成音频": "生成音频",
        "开启音效": "开启音效",
        "静音模式": "静音模式",
        "音频提示": "提示：已上传音频将作为背景音乐，未上传音频时AI将自动生成配乐",
        "开始生成": "开始生成",
        "积分": "积分",
        "生成中": "生成中",
        "生成成功": "生成成功",
        "视频生成成功！": "视频生成成功！",
        "作品已保存到": "作品已保存到「我的作品」",
        "继续创作": "继续创作",
        "查看作品": "查看作品",
        "视频预览": "视频预览",
        "关闭": "关闭",
        "下载视频": "下载视频",
        "您的浏览器不支持视频播放": "您的浏览器不支持视频播放",
        "生成进度": "生成进度",
        "描述": "描述",
        "时长": "时长",
        "秒": "秒",
        "视频素材": "视频素材",
        "音频素材": "音频素材",
        "双图融合模式": "双图融合模式",
        "开始下载视频": "开始下载视频",
        "请输入视频描述": "请输入视频描述",
        "请至少上传一张图片": "请至少上传一张图片",
        "请至少上传一张图片或一个视频": "请至少上传一张图片或一个视频",
        "最多只能上传": "最多只能上传",
        "超过": "超过",
        "限制": "限制",
        "不是图片文件": "不是图片文件",
        "不是视频文件": "不是视频文件",
        "不是音频文件": "不是音频文件"
    },
    Forgot: {
        "找回密码": "找回密码",
        "请输入您的邮箱，我们将发送验证码": "请输入您的邮箱，我们将发送验证码",
        "密码重置成功，请使用新密码登录": "密码重置成功，请使用新密码登录",
        "密码重置成功": "密码重置成功",
        "您的密码已成功重置，请使用新密码登录": "您的密码已成功重置，请使用新密码登录",
        "立即登录": "立即登录",
        "邮箱": "邮箱",
        "请输入注册邮箱": "请输入注册邮箱",
        "发送验证码": "发送验证码",
        "请输入验证码": "请输入验证码",
        "验证码": "验证码",
        "新密码": "新密码",
        "设置新密码": "设置新密码",
        "确认新密码": "确认新密码",
        "再次输入新密码": "再次输入新密码",
        "重置密码": "重置密码",
        "返回登录": "返回登录",
        "验证中": "验证中",
        "重置中": "重置中",
        "弱": "弱",
        "中": "中",
        "强": "强",
        "请输入邮箱地址": "请输入邮箱地址",
        "请输入正确的邮箱格式": "请输入正确的邮箱格式",
        "验证码应为6位数字": "验证码应为6位数字",
        "请输入新密码": "请输入新密码",
        "密码至少需要6位": "密码至少需要6位",
        "请再次输入新密码": "请再次输入新密码",
        "两次输入的密码不一致": "两次输入的密码不一致",
        "验证码已发送": "验证码已发送"
    },
    Login: {
        "下一代AI视频生成平台": "下一代AI视频生成平台",
        "一键生成": "一键生成",
        "支持4K超高清输出": "支持4K超高清输出",
        "多种风格模板任选": "多种风格模板任选",
        "商用授权无忧使用": "商用授权无忧使用",
        "欢迎回来": "欢迎回来",
        "登录您的账号继续创作": "登录您的账号继续创作",
        "邮箱": "邮箱",
        "请输入邮箱地址": "请输入邮箱地址",
        "密码": "密码",
        "请输入您的密码": "请输入您的密码",
        "记住我": "记住我",
        "忘记密码？": "忘记密码？",
        "登录": "登录",
        "登录中": "登录中",
        "还没有账号？": "还没有账号？",
        "立即注册": "立即注册",
        "请输入正确的邮箱格式": "请输入正确的邮箱格式",
        "请输入密码": "请输入密码",
        "密码至少需要6位": "密码至少需要6位",
        "密码不能超过20位": "密码不能超过20位",
        "登录成功": "登录成功"
    },
    Register: {
        "创建账号": "创建账号",
        "开始您的AI视频创作之旅": "开始您的AI视频创作之旅",
        "姓名": "姓名",
        "请输入您的姓名": "请输入您的姓名",
        "邮箱": "邮箱",
        "请输入邮箱地址": "请输入邮箱地址",
        "获取验证码": "获取验证码",
        "验证码": "验证码",
        "请输入验证码": "请输入验证码",
        "密码": "密码",
        "设置密码": "设置密码",
        "确认密码": "确认密码",
        "再次输入密码": "再次输入密码",
        "我已阅读并同意": "我已阅读并同意",
        "服务条款": "服务条款",
        "和": "和",
        "隐私政策": "隐私政策",
        "注册中": "注册中",
        "已有账号？": "已有账号？",
        "立即登录": "立即登录",
        "弱": "弱",
        "中": "中",
        "强": "强",
        "请输入姓名": "请输入姓名",
        "姓名至少需要2个字符": "姓名至少需要2个字符",
        "姓名不能超过20个字符": "姓名不能超过20个字符",
        "请输入正确的邮箱格式": "请输入正确的邮箱格式",
        "验证码应为6位数字": "验证码应为6位数字",
        "请输入密码": "请输入密码",
        "密码至少需要6位": "密码至少需要6位",
        "密码不能超过20位": "密码不能超过20位",
        "请再次输入密码": "请再次输入密码",
        "两次输入的密码不一致": "两次输入的密码不一致",
        "验证码已发送": "验证码已发送",
        "注册成功": "注册成功"
    },
    Faq: {
        '常见问题': '常见问题',
        '您在使用过程中遇到的问题': '您在使用过程中遇到的问题，在这里都可以找到答案',
        '搜索您的问题': '搜索您的问题...',
        '没有找到相关的问题': '没有找到相关的问题',
        '查看全部问题': '查看全部问题',
        '没有找到您想要的答案？': '没有找到您想要的答案？',
        '我们的客服团队随时为您提供帮助': '我们的客服团队随时为您提供帮助',
        '复制客服邮箱': '复制客服邮箱',
        '链接已复制到剪贴板': '链接已复制到剪贴板'
    },
    Home: {
        '立即订阅': '立即订阅',
        'AI视频生成新时代': 'AI视频生成新时代',
        '用文字创造': '用文字创造',
        '无限视频': '无限视频',
        '让每个人都能成为视频创作者': '让每个人都能成为视频创作者。只需输入文字描述，即可生成高质量、独特的AI视频。',
        '免费开始': '免费开始',
        '观看演示': '观看演示',
        'AI生成': 'AI生成',
        'AI视频': 'AI视频',
        '三步轻松生成专业视频': '三步轻松生成专业视频',
        '输入提示词': '输入提示词',
        '用文字描述您想要的视频内容': '用文字描述您想要的视频内容，越详细效果越好',
        '智能生成': '智能生成',
        'AI模型自动理解并创作': 'AI模型自动理解并创作，几分钟完成渲染',
        '下载作品': '下载作品',
        '高清视频生成完成': '高清视频生成完成，可立即下载使用',
        'AI视频生成': 'AI视频生成',
        '精彩视频': '输入文字描述，AI将为您生成精彩视频',
        '描述您想要的视频场景': '描述您想要的视频场景，例如：一只猫咪在樱花树下玩耍，阳光透过花瓣洒下...',
        '生成中': '生成中...',
        '生成视频': '生成视频',
        'AI图片': 'AI图片',
        '精美图片': '输入文字描述，AI将为您生成',
        '描述您想要的图片场景': '描述您想要的图片场景，例如：未来城市的天际线，霓虹灯闪烁，赛博朋克风格...',
        '生成图片': '生成图片',
        '强大功能': '强大功能',
        '让视频创作变得简单有趣': '让视频创作变得简单有趣',
        '案例展示': '案例展示',
        '来看看用户使用': '来看看用户使用',
        '创作的精彩作品': '创作的精彩作品',
        '新闻资讯': '新闻资讯',
        '了解': '了解',
        '的最新动态和产品更新': '的最新动态和产品更新',
        '查看更多': '查看更多',
        '热门': '热门',
        '最新': '最新',
        '阅读更多': '阅读更多',
        '选择适合您的方案': '选择适合您的方案',
        '灵活的定价': '灵活的定价，满足不同需求',
        '视频预览': '视频预览',
        '生成成功': '生成成功',
        '作品已保存到': '作品已保存到"我的创作"中',
        '继续创作': '继续创作',
        '查看作品': '查看作品',
        '请输入视频描述': '请输入视频描述',
        '视频生成成功！': '视频生成成功！',
        '请输入图片描述': '请输入图片描述',
        '图片生成成功！': '图片生成成功！'
    },
    News: {
        '新闻资讯': '新闻资讯',
        '了解': '了解',
        '的最新动态和产品更新': '的最新动态和产品更新',
        '精选': '精选',
        '阅读': '阅读',
        '点赞': '点赞',
        '热门': '热门',
        '最新': '最新',
        '阅读更多': '阅读更多',
        '加载中': '加载中...',
        '暂无新闻': '暂无新闻',
        '清除筛选': '清除筛选',
        '加载新闻失败': '加载新闻失败，请稍后重试',
    },
    Price: {
        '选择适合您的方案': '选择适合您的方案',
        '灵活的定价': '灵活的定价，满足不同需求',
        '包月': '包月',
        '包年': '包年',
        '购买积分': '购买积分',
        '只需要几个视频': '只需要几个视频？无需订阅，直接购买积分包',
        '产品大全': '产品大全',
        '了解': '了解',
        '全系列产品的详细信息和支付方式': '全系列产品的详细信息和支付方式'
    },
    Billing: {
        '账单管理': '账单管理',
        '账户余额': '账户余额',
        '本月支出': '本月支出',
        '订单数量': '订单数量',
        '账单列表': '账单列表',
        '请选择类型': '请选择类型',
        '请选择时间范围': '请选择时间范围',
        '订单号': '订单号',
        '类型': '类型',
        '金额': '金额',
        '状态': '状态',
        '时间': '时间',
        '操作': '操作',
        '查看详情': '查看详情',
        '下载发票': '下载发票',
        '暂无作品': '暂无作品',
        '去创作': '去创作',
        '支付方式': '支付方式',
        '添加支付方式': '添加支付方式',
        '默认': '默认',
        '设为默认': '设为默认',
        '编辑': '编辑',
        '删除': '删除',
        '账单详情': '账单详情',
        '交易流水号': '交易流水号',
        '关闭': '关闭',
        '账号': '账号/卡号',
        '请输入账号或卡号': '请输入账号或卡号',
        '姓名': '姓名',
        '请输入持卡人姓名': '请输入持卡人姓名',
        '有效期': '有效期',
        '请输入CVV码': '请输入CVV码',
        '取消': '取消',
        '确认添加': '确认添加',
        '确认修改': '确认修改',
        '确认删除': '确认删除',
        '编辑支付方式': '编辑支付方式',
        '确定要删除支付方式': '确定要删除支付方式',
        '删除后不可恢复': '删除后不可恢复，请谨慎操作！',
        '请输入账号': '请输入账号/卡号',
        '添加成功': '添加成功',
        '修改成功': '修改成功',
        '已设为默认支付方式': '已设为默认支付方式',
        '删除成功': '删除成功',
    },
    Credit: {
        '额度管理': '额度管理',
        '当前可用额度': '当前可用额度',
        '升级会员': '升级会员',
        '本月已用': '本月已用',
        '视频生成': '视频生成',
        'AI图片': 'AI图片',
        '其他': '其他',
        '购买额度包': '购买额度包',
        '最受欢迎': '最受欢迎',
        '额度': '额度',
        '立即购买': '立即购买',
        '使用记录': '使用记录',
        '操作': '操作',
        '类型': '类型',
        '额度变动': '额度变动',
        '时间': '时间',
        '购买': '购买',
        '确认购买': '确认购买',
        '金额': '金额：',
        '获得': '获得',
        '取消': '取消',
        '今天': '今天',
        '昨天': '昨天',
    },
    Dashboard: {
        '欢迎回来': '欢迎回来，',
        '创建新视频': '创建新视频',
        '本月生成次数': '本月生成次数',
        '剩余额度': '剩余额度',
        '总视频数': '总视频数',
        '会员状态': '会员状态',
        '最近生成': '最近生成',
        '查看全部': '查看全部',
        '视频预览': '视频预览',
        '视频生成中': '视频生成中，请稍后预览',
    },
    Membership: {
        '会员中心': '会员中心',
        '当前方案': '当前方案',
        'Pro 会员': 'Pro 会员',
        '专业创作者首选': '专业创作者首选',
        '月': '月',
        '会员有效期': '会员有效期',
        '剩余天数': '剩余天数',
        '续费会员': '续费会员',
        '取消订阅': '取消订阅',
        '本月使用情况': '本月使用情况',
        '视频生成': '视频生成',
        '次': '次',
        '额度使用': '额度使用',
        '快速生成': '快速生成',
        '升级方案': '升级方案',
        '联系销售': '联系销售',
        '会员权益': '会员权益',
        '续费后将延长会员有效期30天': '续费后将延长会员有效期30天',
        '取消': '取消',
        '确认续费': '确认续费',
        '取消后您将失去所有会员权益': '取消后您将失去所有会员权益，剩余额度将保留',
        '再想想': '再想想',
        '确认取消': '确认取消',
        '姓名': '姓名',
        '请输入您的姓名': '请输入您的姓名',
        '请输入姓名': '请输入姓名',
        '公司': '公司',
        '请输入公司名称': '请输入公司名称',
        '邮箱': '邮箱',
        '请输入邮箱地址': '请输入邮箱地址',
        '请输入邮箱': '请输入邮箱',
        '请输入正确的邮箱格式': '请输入正确的邮箱格式',
        '需求': '需求',
        '请描述您的需求': '请描述您的需求',
        '提交': '提交',
        '请填写需求': '请填写需求',
        '续费成功': '续费成功！会员有效期已延长',
        '已取消订阅': '已取消订阅，会员将在到期后失效',
        '提交成功': '提交成功，我们会尽快联系您！',
    },
    Task: {
        '生成任务': '生成任务',
        '新建任务': '新建任务',
        '进行中': '进行中',
        '已完成': '已完成',
        '失败': '失败',
        '队列中': '队列中',
        '活跃任务': '活跃任务',
        '刷新': '刷新',
        '暂无活跃任务': '暂无活跃任务',
        '预计剩余': '预计剩余',
        '暂停': '暂停',
        '继续': '继续',
        '取消': '取消',
        '最近完成': '最近完成',
        '查看全部': '查看全部',
        '暂无完成的任务': '暂无完成的任务',
        '播放': '播放',
        '下载': '下载',
        '分享': '分享',
        '确认取消': '确认取消',
        '确定要取消任务吗': '确定要取消任务吗',
        '已消耗的额度将无法退还': '已消耗的额度将无法退还',
        '返回': '返回',
        '分享作品': '分享作品',
        '复制链接': '复制链接',
        '任务列表已刷新': '任务列表已刷新',
        '已暂停': '已暂停',
        '生成中': '生成中',
        '已恢复': '已恢复',
        '任务已取消': '任务已取消',
        '链接已复制到剪贴板': '链接已复制到剪贴板',
    },
    VideoShow: {
        '示例': '示例',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。',
        '全部': '全部',
        '电影感': '电影感',
        '角色': '角色',
        '产品': '产品',
        '自然': '自然',
        '趣味': '趣味',
        '加载中': '加载中',
        '暂无展示': '暂无展示',
        '视频预览': '视频预览',
    },
    Request: {
        '加载中': '加载中...',
        '您已退出登录': '您已退出登录，可以重新登录',
        '确认退出': '确认退出',
        '重新登录': '重新登录',
        '错误': '错误',
        '网络错误': '网络错误',
        '下载中': '下载中...'
    },
    Other: {
        '剩余额度': '剩余额度',
        '去登录': '去登录',
        '请登录后查看': '请登录后查看',
        '任务': '任务',
        '可在「生成任务」中查看详情': '，可在「生成任务」中查看详情',
        '查看详情': '查看详情',
        '排队中': '排队中',
        '运行中': '运行中',
        '取消': '取消',
        '成功': '成功',
        '失败': '失败',
        '超时': '超时',
        '最后更新': '最后更新：',
        '视频生成': '视频生成',
        '活跃用户': '活跃用户',
        '用户评分': '用户评分',
        '万': '万',
        '快速生成': '快速生成',
        '先进的AI模型': '先进的AI模型，几分钟内即可生成高质量视频',
        '多种风格': '多种风格',
        '多种风格任您选择': '写实、动漫、艺术等多种风格任您选择',
        '高清输出': '高清输出',
        '支持4K超高清视频输出': '支持4K超高清视频输出，细节清晰可见',
        '商用授权': '商用授权',
        '生成的视频可用于商业用途': '生成的视频可用于商业用途，无版权担忧',
        '原价': '原价',
        '积分价格说明': '积分价格说明',
        '系列': '系列',
        '模型': '模型',
        '分辨率': '分辨率',
        '积分': '积分',
        '秒': '秒',
        '秒示例': '秒示例',
        '图片模型': '图片模型',
        '图片为': '图片为',
        '系列产品': '系列产品，当前支持',
        '支持使用任意机型查看完整体验': '，支持使用任意机型查看完整体验。',
        '计费方式': '计费方式',
        '张': '张',
        '按生成张数计费': '按生成张数计费',
        '普通用户': '普通用户',
        '无记录': '无记录',
        '总支出': '总支出',
        '月总使用': '月总使用',
        '月视频使用': '月视频使用',
        '月图片使用': '月图片使用',
        '生成成功': '生成成功',
        '视频总生成': '视频总生成',
        '图片总生成': '图片总生成',
        '生成中': '生成中，请耐心等待1-3分钟',
        '来自我们演示库的一套精心挑选的剪辑片段': '来自我们演示库的一套精心挑选的剪辑片段。',
        '最近7天': '最近7天',
        '最近30天': '最近30天',
        '本月': '本月',
        '上月': '上月',
        '选择支付方式': '选择支付方式',
        '确认支付': '确认支付'
    }
}